import React, { useEffect, useState } from "react";
import { Modal, Skeleton } from "antd";
import { Survey } from "survey-react-ui";
import { Model } from "survey-core";
import { GetByIdFormularioResposta, UpdateFormularioResposta } from "@services/Formulario/Index";
import { useSelector } from "react-redux";
import { selectStatusById } from "@store/selectors/solicitacaoSelector";
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { customTheme } from "@styles/survey-ui/survey-custom-theme";
import { surveyLocalization } from "survey-core";
import 'survey-core/i18n/portuguese';
import { formatDateTimeToBR } from "@utils/FormatDate";
surveyLocalization.currentLocale = 'pt';

export const FormularioRespostasModal = ({
  visible,
  onClose,
  formularioId,
  idSolicitacao
}) => {
  const [surveyModel, setSurveyModel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dataEnvioFormulario, setDataEnvioFormulario] = useState("");

  const status = useSelector(selectStatusById(idSolicitacao));
  const podeEditar = status === 3;

  useEffect(() => {
    if (visible && formularioId) {
      fetchResposta();
    }
  }, [visible, formularioId]);

  const fetchResposta = async () => {
    setLoading(true);
    try {
      const response = await GetByIdFormularioResposta(formularioId);
      const resposta = response?.respostaJson;
      const formularioJson = response?.formularioJson;

      if (!resposta || !formularioJson) {
        setSurveyModel(null);
        return;
      }

      const model = new Model(formularioJson);
      model.completeText = "Salvar Respostas";
      model.showCompletedPage = true;
      model.mode = podeEditar ? "edit" : "display";
      model.data = resposta;
      model.applyTheme({
        themeName: "customTheme",
        cssVariables: customTheme.cssVariables
      });

      if (podeEditar) {
        model.onComplete.add(async sender => {
          try {

            const payload = {
              idFormularioModelo: response.idFormularioModelo,
              formularioJson: JSON.stringify(sender.toJSON()),
              respostaJson: JSON.stringify(sender.data),
            };

            await UpdateFormularioResposta(formularioId, payload);
            SweetAlert.toastSuccess("Resposta atualizada com sucesso.");
            
            //onClose();
          } catch (error) {
            console.error("Erro ao atualizar resposta:", error);
            SweetAlert.toastError("Erro ao atualizar resposta.");
          }
        });
      }

      setSurveyModel(model);
      setDataEnvioFormulario(response.dataEnvio);
    } catch (error) {
      console.error("Erro ao buscar resposta:", error);
      setSurveyModel(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Resposta salva em: ${formatDateTimeToBR(dataEnvioFormulario)}`}
      getContainer={false}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width="60%"
      destroyOnClose
    >
      <div style={{ minHeight: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {loading ? (
          <div style={{ width: "100%", margin: 10 }}>
            <Skeleton
              active
              paragraph={{ rows: 8, width: ["100%", "80%", "90%", "100%", "60%", "80%", "80%", "90%"] }}
              title={{ width: "40%" }}
              style={{ marginTop: 20 }}
            />
          </div>
        ) : (
          <div style={{ maxHeight: '80vh', overflowY: 'auto', width: "100%", margin: 10 }}>
            {surveyModel
              ? <Survey model={surveyModel} />
              : <p>Nenhum formulário encontrado.</p>
            }
          </div>
        )}
      </div>
    </Modal>
  );
}